import { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { DropdownItem, FormInput, Row } from "shards-react";
import { updateComments } from "utils/redux/actions";
import { useRequestHook } from "utils/hooks/hooks";

const CommentarField = ({
  dispatch,
  docId,
  columnComment,
  columnId,
  services,
}) => {
  const [displayInput, setDisplayInput] = useState(() => false);
  const [comment, setComment] = useState(() => columnComment);
  const [errors, setErrors] = useState(() => columnComment);
  const [maxCommentLength, setMaxCommentLength] = useState(25); // Standard Wert
  const inputRef = useRef();
  const dropDownRef = useRef();
  const { handleRequest } = useRequestHook();

  useEffect(() => {
    const serviceLink = document.querySelector("a.nav-link.active");
    if (serviceLink) {
      const serviceNameElement = serviceLink.querySelector("span:last-child");
      const serviceName = serviceNameElement
        ? serviceNameElement.textContent.trim()
        : null;

      if (serviceName && services) {
        const foundService = services.find(
          (service) => service.name === serviceName
        );
        if (foundService) {
          const maxLength = foundService.mainModule["-commentlength"] || 25; // Default zu 25
          setMaxCommentLength(maxLength); // Länge setzen
        } else {
          console.error("Service nicht gefunden:", serviceName);
        }
      }
    } else {
      console.error("Aktueller Service-Link nicht gefunden!");
    }
  }, [services]);

  const handleInputChange = useCallback(({ target }) => {
    if (target.value.includes("_")) {
      setErrors([<span className="text-danger">'_' ist nicht erlaubt</span>]);
    } else if (target.value.includes("*")) {
      setErrors([<span className="text-danger">'*' ist nicht erlaubt</span>]);
    } else {
      setErrors([]);
      setComment(target.value);
    }
  }, []);

  const handleCommentUpdate = () => {
    const updatedComment = { [columnId]: comment };

    handleRequest(
      "post",
      "/documents/update-comment",
      {
        docId,
        updatedComment,
      },
      (response) => (response ? dispatch(updateComments(updatedComment)) : null)
    );
  };

  useEffect(() => {
    return () => {
      if (dropDownRef.current === null) handleCommentUpdate();
    };
  });

  return (
    <DropdownItem
      ref={dropDownRef}
      tag="div"
      className="px-2 py-1 rounded"
      toggle={false}
    >
      <Row
        noGutters
        className="align-items-center pointer"
        onClick={() => setDisplayInput((oldState) => !oldState)}
      >
        <div className="dropdown-icon">
          <i className="far fa-comment-alt text-warning" />
        </div>
        <strong className="text-dark ml-2 text-nowrap">Kommentar</strong>
      </Row>
      {displayInput && (
        <Row noGutters>
          <FormInput
            autoFocus
            innerRef={inputRef}
            className="comment-field"
            autoComplete="false"
            spellCheck="false"
            maxLength={maxCommentLength}
            value={comment}
            onChange={handleInputChange}
          />
          <div className="error-container">
            {typeof errors === "string" &&
              errors
                .split(/(.{30})/)
                .filter(Boolean)
                .map((chunk, index) => <div key={index}>{chunk}</div>)}
          </div>
          <div className="ml-auto">{`${comment.length}/${maxCommentLength}`}</div>{" "}
        </Row>
      )}
    </DropdownItem>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { id: docId } = state.savedDocument;
  const { comments = {} } = state.savedDocument;
  const { columnId } = ownProps;
  const { [columnId]: columnComment = "" } = comments;
  const { services } = state.userData;

  return { docId, columnComment, services };
};

export default connect(mapStateToProps)(CommentarField);
